import { render, staticRenderFns } from "./ValidationProperties.vue?vue&type=template&id=552da5e6"
import script from "./ValidationProperties.vue?vue&type=script&lang=js"
export * from "./ValidationProperties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports